"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBSearchFilter;
require("core-js/modules/esnext.iterator.map.js");
var _react = _interopRequireDefault(require("react"));
var _Dropdown = _interopRequireDefault(require("react-bootstrap/Dropdown"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable */

function SVBSearchFilter(props) {
  const {
    filterJsonData,
    getSelectedFilter,
    extraClasses
  } = props;
  const handleClick = (e, value) => {
    e.preventDefault();
    getSelectedFilter(value);
  };
  const finalClass = !extraClasses ? 'col-md-12' : extraClasses;
  const CustomToggle = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
    let {
      children,
      onClick: _onClick
    } = _ref;
    return /*#__PURE__*/_react.default.createElement("a", {
      className: "label-dropdown",
      href: "#",
      ref: ref,
      onClick: e => {
        e.preventDefault();
        _onClick(e);
      }
    }, children, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-chevron-down ps-2"
    }));
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "search-filters",
    className: finalClass
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-md-flex align-items-center justify-content-between p-3 pe-0 mb-3"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "filter-label"
  }, "Filter by:"), /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-types d-md-inline-flex ms-md-3 col-xs-12 "
  }, filterJsonData.map((item, i) => {
    return item !== null && item !== void 0 && item.options ? /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
      key: i,
      bsPrefix: "category-tag px-2 me-3 dropdown d-inline-block"
    }, /*#__PURE__*/_react.default.createElement(_Dropdown.default.Toggle, {
      as: CustomToggle
    }, item === null || item === void 0 ? void 0 : item.name), /*#__PURE__*/_react.default.createElement(_Dropdown.default.Menu, {
      className: "mw-100"
    }, (item === null || item === void 0 ? void 0 : item.options) && (item === null || item === void 0 ? void 0 : item.options.map((dropdownItem, z) => {
      return /*#__PURE__*/_react.default.createElement(_Dropdown.default.Item, {
        key: "".concat(i).concat(z),
        onClick: e => handleClick(e, dropdownItem)
      }, dropdownItem);
    })))) : /*#__PURE__*/_react.default.createElement("a", {
      key: i,
      href: "#",
      onClick: e => handleClick(e, item === null || item === void 0 ? void 0 : item.name),
      className: "category-tag px-2 me-3"
    }, item === null || item === void 0 ? void 0 : item.name);
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "ms-auto enter-description"
  }, "Press ENTER to see results")));
}
SVBSearchFilter.propTypes = {
  getSelectedFilter: _propTypes.default.func,
  extraClasses: _propTypes.default.string
};